import delve from 'dlv'
import { dset as set } from 'dset'
import { Subject } from 'rxjs'

import { flattenTreeToEstimatesUpdate } from './budgetEstimatesUtils'

class BudgetEstimatesCalculator {
	private currentEstimates: any = {}
	private subject = new Subject<string>()
	public update(key: string, value: number | boolean) {
		set(this.currentEstimates, key, value)
		this.subject.next(key)
		const keyArray = key.split('.')

		keyArray.pop()
		while (keyArray.length > 0) {
			const totalKey = keyArray.concat('total')
			let updatedTotal = delve(this.currentEstimates, totalKey)
			const total = delve(this.currentEstimates, totalKey)

			const keyNode = delve(this.currentEstimates, keyArray)
			if (
				Object.keys(keyNode).every((key) => typeof keyNode[key] === 'number')
			) {
				updatedTotal = Object.keys(keyNode).reduce(
					(total, key) => (key !== 'total' ? total + keyNode[key] : total),
					0,
				)
			} else {
				updatedTotal = Object.keys(keyNode).reduce(
					(total, key) =>
						typeof keyNode?.[key]?.total === 'number'
							? total + keyNode[key].total
							: total,
					0,
				)
			}
			if (updatedTotal !== total) {
				set(this.currentEstimates, totalKey, updatedTotal)
				this.subject.next(totalKey.join('.'))
			}
			keyArray.pop()
		}
	}

	public setInitial = (object: any) => {
		this.currentEstimates = JSON.parse(JSON.stringify(object))
	}

	public getValue = (key: string) => {
		return delve(this.currentEstimates, key)
	}

	public subscribe = (callback: (updatedKey: string) => void) => {
		const unsubscribe = this.subject.subscribe(callback)

		return () => unsubscribe.unsubscribe()
	}

	public getEstimates = () => {
		return this.currentEstimates
	}

	public getEstimatesForSubmit = () => {
		const flattenedEstimates = flattenTreeToEstimatesUpdate(
			this.currentEstimates.tree,
		)
		const disposableAmount =
			flattenedEstimates.income! + flattenedEstimates.expenses!

		if (this.currentEstimates.insights) {
			return {
				...flattenedEstimates,
				disposableAmount,
				insights: this.currentEstimates.insights,
			}
		}
		return {
			...flattenedEstimates,
			disposableAmount,
		}
	}
}

export const budgetEstimatesCalculatorService = new BudgetEstimatesCalculator()
